import { createContext } from 'react';

export interface AppFlags {
  enableDonateToTeam: boolean;
  virtualFitnessEventsPreview: boolean;
  virtualFitnessEventsDebugFeatures: boolean;
  useCutterForSocialSharing: boolean;
  enableOtgImmersiveGiving: boolean;
  enableOtgAuction: boolean;
  enableOtgVideoChat: boolean;
}

export const FlagsContext = createContext<AppFlags>({
  enableDonateToTeam: false,
  enableOtgAuction: false,
  enableOtgImmersiveGiving: false,
  enableOtgVideoChat: false,
  useCutterForSocialSharing: false,
  virtualFitnessEventsDebugFeatures: false,
  virtualFitnessEventsPreview: false,
});
FlagsContext.displayName = 'FlagsContext';

export const FlagsProvider = FlagsContext.Provider;
export const FlagsConsumer = FlagsContext.Consumer;
